import React from 'react'
import Navbar from '../../components/Navbar'
import { Scroll } from './Scroll'

export const Home = ({setc}) => {

   setc("transparent")
     
  return (
    <div>
     
    <Scroll/>

     
    </div>
  )
}
